
    // Search form select fields 
    const fieldIds = {
      makeId: "makeSelect",
      modelId: "modelSelect",
      yearsId: "yearSelect",
      chassisId: "chassisSelect",
      engineId: "engineSelect",
      detailsId: "detailSelect",
    }

    document.addEventListener("DOMContentLoaded", () => {
      // Event listner for Form Submit
      function processFormSubmit() {
        const form = document.getElementById("rego-search-form");
        if (form) {
          form.addEventListener("submit", async (event) => {
            event.preventDefault();
            showLoader(); // Show loading indicator

            // Get Current User IP
            ip = await getUserIP();
            const licencePlate = document.getElementById("plate-input").value;
            let hash = await hashString(ip);
            // if the field is submitted empty
            if (!licencePlate) {
              reset_local_storage();
              alert("Please enter a license plate.");
              hideLoader(); // Hide loading indicator if no plate is entered
              return;
            }

            const apiUrl = "https://my-hono-app.karan-artzen.workers.dev/api/vehicle";

            // API parameters
            const params = new URLSearchParams({
              UserID: "12364",
              AuthCode: "G56-M88-JKJ",
              Country: "NZ",
              State: "NZ",
              LicencePlate: licencePlate,
              AcceptCharge: 1,
              ForceRefreshLevel: 0,
              CallingIPAddress: ip,
              UserCookie: hash,
              UserAccount: "",
            });

            // Fetch data from the API
            const data = await fetchData(apiUrl, params);
            if (data.vehicleData) {
              if(Array.isArray(data.vehicleData)) {
                  let element = document.getElementById('vehicleSelect');
                  element.innerHTML = '<option value="">'+element.getAttribute('placeholder')+'</option>';
                  data.vehicleData.forEach((vehicle) =>{
                    let option =   document.createElement('option');
                    option.text = vehicle.VehicleDescription + "("+vehicle.VehicleId+")";
                    option.value = vehicle.VehicleId;
                    option.setAttribute('data-obj', JSON.stringify(vehicle) );
                    document.getElementById('vehicleSelect').appendChild(option);
                  });
                  document.querySelector('.rego-multi-search').style.display = 'block';
                  hideLoader();
              }else {
                  reset_local_storage();
                  sessionStorage.setItem("vehicleData", JSON.stringify(data.vehicleData));
                  sessionStorage.setItem("licencePlate", licencePlate);
                  handle_search_request();
              }
              // checks if the form is on home page or search page
            } else {
              hideLoader();
              reset_local_storage();
              document.getElementById("groupContainer").innerHTML = "No vehicle found for this license plate.";
              document.querySelector('.my-vehicle-item').style.display = "none";
              hide_thumbnail_img();
            }
          });
        } else {
          console.log("Form element not found.");
        }
      }
      processFormSubmit();

      // displaying and hiding the search forms 
      if(document.getElementById('original-search-link')) {
        document.getElementById('original-search-link').addEventListener('click', function() {
          document.getElementById('pop-out-search').style.display = 'block';
        });
      }

      if(document.getElementById('original-search-close')) {
        document.getElementById('original-search-close').addEventListener('click', function() {
          document.getElementById('pop-out-search').style.display = 'none';
        });
      }

      // displaying and hiding the multi-select search forms 
      if(document.getElementById('multi-search-close')) {
        document.getElementById('multi-search-close').addEventListener('click', function() {
          document.querySelector('.rego-multi-search').style.display = 'none';
        });
      }

    });

    function handle_search_request(){
      const form = document.getElementById("rego-search-form");
      if(!form.classList.contains("search-vehicle")) {
        window.location.href = '/pages/parts-search';
      } else {
        renderGroups();
      }
    }

    // get current user ip
    async function current_user_ip() {
      try {
        const response = await fetch("https://ipinfo.io/json");
        if (!response.ok) throw new Error("Failed to fetch IP address");
        const data = await response.json();
        return data.ip; // Return the IP address
      } catch (error) {
        console.error("Error fetching IP address:", error);
        return '1.2.1.1'; // Return a default IP in case of an error
      }
    };

    // function to wait for the response of API
    async function getUserIP() {
      ip = await current_user_ip();
      return ip;
    };

    function get_saved_plate_number() {
      let licencePlate = sessionStorage.getItem('licencePlate');
      return licencePlate;
    }

    function get_saved_vehicle_data() {
      let storedData = sessionStorage.getItem("vehicleData");
      let parsedData = JSON.parse(storedData);
      return parsedData;
    }

    async function fetchData(apiUrl, params) {
      try {
        const response = await fetch(`${apiUrl}?${params}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }

        const data = await response.json();
        return data;
      } catch (error) {
        console.error('Error fetching data:', error);
        // document.getElementById('results').innerHTML = 'Error fetching data. Please try again.';
      }

    }


    // Getting related products on the click of the groups renderd on left side
    async function get_related_products(groupId, subgroupId = 0, element = "") {
      sessionStorage.setItem('selectedGroup', JSON.stringify({groupId: groupId, subgroupId: subgroupId}) );
      let licencePlate = get_saved_plate_number() ?? "";
      let parsedData = get_saved_vehicle_data();
      if(element) {
        // remove previous selection active
        let preSelected = document.querySelector('.parts-list .active');
        if(preSelected){
          // if(!element.parentElement.parentElement.classList.contains('active-sublist')) {
          //   if(preSelected.nextSibling && preSelected.nextSibling.classList.contains('subparts-list')) {
          //     preSelected.nextSibling.classList.remove('active-sublist') ;
          //   } else {
          //     let parentElement = preSelected.parentElement.parentElement;
          //     if(parentElement && parentElement.classList.contains('subparts-list')) {
          //       parentElement.classList.remove('active-sublist') ;
          //     } 
          //   }
          // }
          
          preSelected.classList.remove('active');
        }

        // displaying at top the current selected group
        // document.querySelector('.current-group-name').innerText = element.innerText;
        element.classList.add('active');
      }
      if(groupId) {
        document.querySelector(".search-products .product-groups").innerHTML = "";
        // for(dataGroup of allGroupsParsed[element.innerText]) {
          showLoader(); // Show loading indicator
          let ip = await getUserIP();
          let hash = await hashString(ip);
          var apiUrl = "https://my-hono-app.karan-artzen.workers.dev/api/group-part-list";
          // document.querySelector(`li[data-group-id='${groupId}'] .subparts-list`).style.display = "block";
          // document.querySelector(`li[data-group-id='${groupId}'] .subparts-list`).classList.add("active-sublist");
          // API parameters
          const params = new URLSearchParams({
            UserID: "12364",
            AuthCode: "G56-M88-JKJ", // Be careful with sensitive information like AuthCode
            Country: "NZ",
            State: "NZ",
            LicencePlate: licencePlate,
            CallingIPAddress: ip,
            UserCookie: hash,
            vehicleId: parsedData.VehicleId,
            partGroupId: groupId,
            SubGroup: subgroupId,
            Layout: 0,
            catType: parsedData.CatType,
          });
          const data = await fetchData(apiUrl, params);

          let aapis = [];
          subgroups = {};
          longFootNote = {};
          console.log(data.groupPartLists);
          // Map the AAPI keys to get the realted products by matching it with product tags
          if( data.groupPartLists ) {
            if(Array.isArray(data.groupPartLists)) {
              data.groupPartLists.forEach((item) => {
                subCatId = String(item.SubcatID)+"-subcat";
                if(!subgroups[subCatId]) {
                  subgroups[subCatId] = {};
                  subgroups[subCatId].aapis = [];

                }
                if(!longFootNote[item.AAPI]) {
                  longFootNote[item.AAPI] = item.LongFootnote;
                }

                subgroups[subCatId].aapis.push(item.AAPI); 
                subgroups[subCatId].name = item.SubCatDescription;
                subgroups[subCatId].id = item.SubGroupID;
              });
            } else {
              subCatId = String(data.groupPartLists.SubcatID)+"-subcat";
              if(!subgroups[subCatId]) {
                subgroups[subCatId] = [];
              }
              if(!ongFootNote[data.groupPartLists.AAPI]) {
                longFootNote[data.groupPartLists.AAPI] = data.groupPartLists.LongFootnote;
              }
              subgroups[subCatId].push(data.groupPartLists.AAPI);
            }
            sessionStorage.setItem('longFootNote', JSON.stringify(longFootNote));
            sessionStorage.setItem('aapis', JSON.stringify(subgroups));
            const temp = document.createElement("div");
            dataHtml = "";
            for(subCatId in subgroups)  {
              const arrayString = subgroups[subCatId].aapis.join(',');
              const subcatName = subgroups[subCatId].name;
              const subGroupId = subgroups[subCatId].id;
              productsData = await get_products(arrayString, subCatId);
              containerHtml = await renderProducts(productsData.products);
              if(containerHtml) {
                temp.innerHTML = "<div class='sub-group-wrapper' data-subcatid='"+subCatId+"'><div class='current-group-name'>"+subcatName+"</div>"+containerHtml+"</div>";
                document.querySelector(".search-products .product-groups").append(...temp.childNodes) ; 

                if(!data.groupPartLists || productsData.pageInfo.hasNextPage == false) {
                  hideShowMore(subCatId);
                } else {
                  showShowMore(subCatId);
                } 
                attachAddToCartListeners();
              }
            }
            if(document.querySelector(".search-products .product-groups").innerHTML == ""){
              document.querySelector(".search-products .product-groups").innerHTML = '<div class="no-products"><div class="oops-text">OOPS</div><div class="not-listed-text" >N<span class="rotate-text" >IO</span>T LISTED</div><div class="sorry-text" >S<span class="rotate-text" >IO</span>RRY </div><div class="description-text">We can still supply you this part</div><h1 style="color:red; font-size:2em; text-align:center; font-weight:bold;">SEND US AN ENQUIRY</h1><form id="ContactForm" class="enquiry-form" method="post" action="/contact#popup-form"><input type="hidden" name="form_type" value="contact" /><input type="hidden" name="utf8" value="✓" /><div class="field"> <input class="field__input" type="text" name="contact[name]" placeholder="Enter your name" required  /></div><div class="field"> <input class="field__input" type="text" name="contact[email]" placeholder="Enter your email address or phone number" required /></div><div class="field"> <input class="field__input" type="text" name="contact[tags]" placeholder="Enter your rego:" required /></div><div class="field"><textarea row="10" class="text-area field__input" name="contact[body]" placeholder="Enter the part/parts you need" rows="4" required ></textarea></div><div class="contact__button"><button type="submit" class="button" >SEND</button></div></form></div>';
            } else {
              renderLongfootNote();
            }

          } else {
            containerHtml = '<h2 class="no-products">No Products Found</h2>';
          }
            // <img class='search-products-img' src="//tinkr.co.nz/cdn/shop/t/3/assets/happy_browsing.jpg?v=29944904725542351511741595103" />  
        // }
        hideLoader(); // Hide loader after response
        // scroll_element('.search-products');
      }
    }

    function renderLongfootNote(){
      productsList = document.querySelectorAll(".tinkr-search-card-product");
      productsList.forEach((element, index) => {
        contentWrapper = element.querySelector(".card-information");
        longFootNote = sessionStorage.getItem("longFootNote");
        longFootNote = JSON.parse(longFootNote);
        if(longFootNote[element.dataset.aapi] != "") {
          if(contentWrapper.querySelector(".longfootnote-wrapper") == undefined) {
            container = document.createElement("div");
            // let html = '<div class="long-footnote-container">! <div class="longfootnote-text">'+longFootNote[element.dataset.aapi]+'</div></div>';
            let html = '<div class="long-footnote-label">Notes: </div> <div class="longfootnote-content">'+longFootNote[element.dataset.aapi]+'</div>';
            container.classList.add("longfootnote-wrapper");
            container.innerHTML = html;
            contentWrapper.prepend(container);
          }
        }
      });
    }

    async function get_products(aapis, subCatId, showMore = false) {
      let apiUrl = "https://my-hono-app.karan-artzen.workers.dev/api/product-list";
      let payload = {
        tags: aapis,
        limit: 10,
      };

      sectionPageInfo = sessionStorage.getItem("pageInfo-"+subCatId);
      if(sectionPageInfo  && showMore) {
        storage = JSON.parse(sectionPageInfo);
        if(storage.hasNextPage){
          payload.nextPage = "true";
          payload.pageToken = storage.endCursor;
        }
      }
      const params = new URLSearchParams(payload);
      let productsData = await fetchData(apiUrl, params);
      sessionStorage.setItem("pageInfo-"+subCatId, JSON.stringify(productsData.pageInfo));
      return productsData;
    }

    function hideShowMore(subCatId) {
      element = document.querySelector(`.sub-group-wrapper[data-subcatid="${subCatId}"] .show-more-button`);
      if(element) {
        document.querySelector(`.sub-group-wrapper[data-subcatid="${subCatId}"] .show-more-button`).style.display = "none";
        document.querySelector(`.sub-group-wrapper[data-subcatid="${subCatId}"] .show-more-button`).style.disabled = "true";
      }
    }
    function showShowMore(subCatId) {
      element = document.querySelector(`.sub-group-wrapper[data-subcatid="${subCatId}"] .show-more-button`);
      if(element) {
        document.querySelector(`.sub-group-wrapper[data-subcatid="${subCatId}"] .show-more-button`).style.display = "block";
        document.querySelector(`.sub-group-wrapper[data-subcatid="${subCatId}"] .show-more-button`).style.disabled = "false";
      }
    }


    async function showMoreProducts(element) {
      showLoader();
      parent = element.closest('.sub-group-wrapper');
      // e.preventDefault();
      aapis = JSON.parse(sessionStorage.getItem("aapis"));
      aapis = aapis[parent.dataset.subcatid].aapis;
      queryString = aapis.join(',');
      productsData = await get_products(queryString, parent.dataset.subcatid, true);
      if(productsData.products.length) {
        // const params = new URLSearchParams();
        let handles = [];
        for(product of productsData.products ){
          const productNode = product.node;
          let arr = productNode.id.split('/');
          // Get the last element
          let lastElement = arr[arr.length - 1];
          handles.push(productNode.handle);
        }
        const queryString = handles.join(',');
        productsHtml = await loadProductHtml(queryString, true);
        parent.querySelector(".products-container").innerHTML = parent.querySelector(".products-container").innerHTML + productsHtml;
        renderLongfootNote();
      }
      if(productsData.pageInfo.hasNextPage == false) {
        hideShowMore(parent.dataset.subcatid);
      } else {
        showShowMore(parent.dataset.subcatid);
      }
      hideLoader();
    }


    function renderSelectedGroup(){
      showLoader();
      storedData = sessionStorage.getItem('selectedGroup');
      if(storedData == null ) {
        hideLoader();
        return;
      }
      let parsedData = JSON.parse(storedData);
      elementSelector = 'p[onclick="get_related_products('+parsedData.groupId+', '+parsedData.subgroupId+', this);"]';
      element = document.querySelector(elementSelector);
      get_related_products(parsedData.groupId, parsedData.subgroupId, element);
    }

    // Render groups on left side by getting the data from local storage
    async function renderGroups(){
      showLoader();
      hide_thumbnail_img();
      let licencePlate = get_saved_plate_number() ?? "";
      let parsedData = get_saved_vehicle_data();
      let groupContainer = document.getElementById("groupContainer");
      if(groupContainer) {
        if(sessionStorage.length === 0 || parsedData == null) {
          hideLoader();
          groupContainer.innerHTML = 'Please search for a vehicle.';
          return;
        }

        // Set the default value of search field on parts search page
        // document.getElementById('plate-input').value = licencePlate;
        let ip = await getUserIP();
        let hash = await hashString(ip);
        // display current vehicle name
        document.getElementById('active-Vehicle').innerText = parsedData.VehicleDescription;
        var apiUrl = "https://my-hono-app.karan-artzen.workers.dev/api/vehicle-part-list";

        // API parameters
        const params = new URLSearchParams({
          UserID: "12364",
          AuthCode: "G56-M88-JKJ",
          Country: "NZ",
          State: "NZ",
          LicencePlate: licencePlate,
          AcceptCharge: 1,
          ForceRefreshLevel: 0,
          CallingIPAddress: ip,
          UserCookie: hash,
          vehicleId : parsedData.VehicleId,
          catType: parsedData.CatType,
        });
        const data = await fetchData(apiUrl, params);
        if(data.partGroupLists){
          // Create an object to group by PartGroupDescription
          let groupedData = {};
          let subGroups = {};
          // Loop through the parts data and group by PartGroupDescription
          data.partGroupLists.forEach(item => {
              if (!groupedData[item.PartGroupDescription]) {
                groupedData[item.PartGroupDescription] = [];
              }
              if(!subGroups[item.SubGroupID]) {
                subGroups[item.SubGroupID] = item.SubGroupDescription;
              }
              groupedData[item.PartGroupDescription].push(item);
              // groupedData[item.PartGroupDescription].groupId = PartGroupID;
          });
          // Create the HTML list dynamically
          let htmlContent = '<ul class="parts-list">';
          sessionStorage.setItem("allSubGroups", JSON.stringify(subGroups));
          groupsRendered = [];
          for (let partGroup in groupedData) {
            // if(groupsRendered.includes(groupedData[partGroup][0].PartGroupID)){
            //   continue;
            // }

            groupsRendered.push(groupedData[partGroup][0].PartGroupID);
            htmlContent += `<li data-group-id="${groupedData[partGroup][0].PartGroupID}" data-subgroup-id="0">
            <p onclick="get_related_products(${groupedData[partGroup][0].PartGroupID}, 0, this);" >${groupedData[partGroup][0].PartGroupDescription}</div>`;
            htmlContent += '</li>';
          }
          
          htmlContent += '</ul>';
          
          // Insert the HTML content into the document
          document.getElementById('groupContainer').innerHTML = htmlContent; 
          setTimeout(() => {
            show_thumbnail_img();
            renderSelectedGroup();
          }, 500);
        }
      } else {
        hideLoader();
      }
    }

    // Render groups on page load
    renderGroups();

    function hide_thumbnail_img() {
      img_element = document.querySelector('.search-products-img');
      if(img_element) {
        img_element.style.display = 'none';
      }
    }

    function show_thumbnail_img() {
      img_element = document.querySelector('.search-products-img');
      if(img_element) {
        img_element.style.display = 'block';
      }
      document.querySelector('.search-products .product-groups').innerHTML = "";
    }

    function no_products_found() {
      document.querySelector('.products-container').innerHTML = `<h2 class="no-products">No Products Found</h2>`;
      hideShowMore();
      hide_thumbnail_img();
    }

    function reset_local_storage(){
      sessionStorage.removeItem('vehicleData');
      sessionStorage.removeItem('licencePlate');
      sessionStorage.removeItem('selectedGroup');
    }

    async function loadProductHtml(queryString, showMore) {

      try {
        const response = await fetch(`/pages/product-ajax/handle=${queryString}`);
        const html = await response.text();
        // Do something with the returned HTML here if needed
        return html;
      } catch (err) {
        console.error('Failed to load product HTML:', err);
        return null; // Or handle the error differently
      }
    }

    async function renderProducts(products, showMore = false) {
      hide_thumbnail_img();
      let productHtml = '';
      let handles = [];

      if(products.length) {
        // const params = new URLSearchParams();
        for(product of products ){
          const productNode = product.node;
          let arr = productNode.id.split('/');
          // Get the last element
          let lastElement = arr[arr.length - 1];
          handles.push(productNode.handle);


        }
        const queryString = handles.join(',');
        let productsHtml = await loadProductHtml(queryString, showMore);

        containerHtml = '<div><img class="search-products-img" src="//tinkr.co.nz/cdn/shop/t/3/assets/happy_browsing.jpg?v=29944904725542351511741595103" /><div class="product-grid-container scroll-trigger animate--slide-in" id="ProductGridContainer" ata-cascade><div class="collection"><div class="loading-overlay gradient"></div><div id=""><ul id="" class="products-container grid product-grid contains-card--product grid--2-col-tablet-down grid--3-col-desktop">'+productsHtml+'</ul><div class="show-more-wrapper"><button class="show-more-button" onclick="showMoreProducts(this);">Show More</button></div></div></div></div></div>';
        return containerHtml;
        // container.innerHTML = productHtml;
        if(!showMore) {
          scroll_element('.search-products');
        }
      } else {
        if(!showMore){
          return "";
          return '<h2 class="no-products">No Products Found</h2>';
        }

      }
    }

    function showLoader() {
      let loaderElement = document.getElementById("loader");
      if( loaderElement ) {
        loaderElement.style.display = "flex";
        document.querySelector("#loader .spinner").style.display = "block";
      }
    }

    function hideLoader() {
      if(document.getElementById("loader")) {
        setTimeout(() => {
          document.getElementById("loader").style.display = "none";
        }, 2000);
      }
    }

    // Dynamically populate the select field on the base of passed items
    function populateSelect(selectId, items) {
      const select = document.getElementById(selectId);
      if(Array.isArray(items)) {
        items.forEach(item => {

          const option = document.createElement('option');
          option.value = item.SelectText; // assuming the item has 'id' and 'name'
          if(selectId === fieldIds.detailsId) {
            option.setAttribute('data-obj', JSON.stringify(item)); // assuming the item has 'id' and 'name'
            option.value = item.VehicleId; // assuming the item has 'id' and 'name'
          }
          option.textContent = item.SelectText;
          if(select) {
            select.appendChild(option);
          }
        });
      } else {
        const option = document.createElement('option');
        option.value = items.SelectText; // assuming the item has 'id' and 'name'
        if(selectId === fieldIds.detailsId) {
          option.setAttribute('data-obj', JSON.stringify(items)); // assuming the item has 'id' and 'name'
          option.value = items.VehicleId; // assuming the item has 'id' and 'name'
        }
        option.textContent = items.SelectText;
        if(select) {
          select.appendChild(option);
        }
      }
    }

    // Default parameters to get the select fields data
    async function url_default_params(){
      let ip = await getUserIP();
      let hash = await hashString(ip);
      let params = {
        UserID: "12364",
        AuthCode: "G56-M88-JKJ",
        ReturnField: "",
        make: "",
        model: "",
        year: "",
        // series: "",
        // chassis: "",
        serieschassis: "",
        engine: "",
        NZ: "True",
        PA: "True",
        LC: "True",
        MC: "false",
        HC: "false",
        SeriesCheck: "True",
        ChassisCheck: "True",
        CallingIPAddress: ip,
        UserCookie: hash,
        UserAccount: ""
      }

      // setting the fields value in parameters if selected any
      if(document.getElementById(fieldIds.makeId)){
        makeValue = document.getElementById(fieldIds.makeId).value;
        if(makeValue) {
          params.make = makeValue;
        }      
      }

      if(document.getElementById(fieldIds.modelId)) {
        modelValue = document.getElementById(fieldIds.modelId).value;
        if(modelValue) {
          params.model = modelValue;
        }
      }

      if(document.getElementById(fieldIds.yearsId)){
        yearValue = document.getElementById(fieldIds.yearsId).value;
        if(yearValue) {
          params.year = yearValue;
        }
      }
      if(document.getElementById(fieldIds.chassisId)){
        chassisValue = document.getElementById(fieldIds.chassisId).value;
        if(chassisValue) {
          params.serieschassis = chassisValue;
        }
      }

      if(document.getElementById(fieldIds.engineId)) {
        engineValue = document.getElementById(fieldIds.engineId).value;
        if(engineValue) {
          params.engine = engineValue;
        }
      }

      if(document.getElementById(fieldIds.detailsId)) {
        detailsValue = document.getElementById(fieldIds.detailsId).value;
        if(detailsValue) {
          params.ReturnField = detailsValue;
        }
      }

      return params;
    }

    // get the results from API and render the data in fields
    async function render_field_list(params, fieldId, defaultcall = false) {
      var apiUrl = "https://my-hono-app.karan-artzen.workers.dev/api/search-vehicle";
      // API parameters
      const data = await fetchData(apiUrl, params);
      if(data.data) {
        populateSelect(fieldId, data.data);
      } else {
        alert("please select different option");
      }
      if(!defaultcall){
        hideLoader();
      }
    }


    // Default function to render the make dropdown on page load
    async function populate_make_list(defaultCall = false){
      let url_params = await url_default_params();
      url_params.ReturnField = 'Make';
      const params = new URLSearchParams(url_params);
      render_field_list(params, fieldIds.makeId, defaultCall);
    }
    populate_make_list(true);

    // get the default API params and add the returnfield param value and pass to render field list
    async function handleSelectChange( nextSelectId, returnField) {
      let url_params = await url_default_params();
      url_params.ReturnField = returnField;
      const params = new URLSearchParams(url_params);
      render_field_list(params, nextSelectId );
    }


    // defined the object to add the change events through the loop
    const selectFields = [
      { fieldId: fieldIds.makeId, nextSelectId: fieldIds.modelId, returnField: "model" },
      { fieldId: fieldIds.modelId, nextSelectId: fieldIds.yearsId, returnField: "year" },
      { fieldId: fieldIds.yearsId, nextSelectId: fieldIds.chassisId, returnField: "serieschassis" },
      { fieldId: fieldIds.chassisId, nextSelectId: fieldIds.engineId, returnField: "engine" },
      { fieldId: fieldIds.engineId, nextSelectId: fieldIds.detailsId, returnField: "details" },
    ];


    // loop on select fields to add the change event
    document.addEventListener("DOMContentLoaded", () => {
      selectFields.forEach( function(field){
        let element = document.getElementById(field.fieldId);
        if(element) {
          document.getElementById(field.fieldId).addEventListener('change', function() {
            showLoader();
            resetNextFields(field.fieldId);
            document.getElementById(field.nextSelectId).removeAttribute("disabled");
            handleSelectChange( field.nextSelectId, field.returnField);
          });
        }
      });
    });

    // Reset all the fields from current selection if the user reselect the values of upper fields
    function resetNextFields(currentField) {
      let fields = Object.values(fieldIds);
      index = fields.indexOf(currentField);
      for (let i = index + 1; i < fields.length; i++) {
        let element = document.getElementById(fields[i]);
        element.innerHTML = '<option value="">'+element.getAttribute('placeholder')+'</option>';
        element.disabled = true;
      }
    }


    // process search filter form submission   
    let searchForm = document.getElementById('Home-Search');
    if(searchForm) {
      document.getElementById('Home-Search').addEventListener('click', (event) => {
        event.preventDefault();
        vehicleId = document.getElementById(fieldIds.detailsId).value;
        if(vehicleId == ""){
          alert('Please select a Body type');
        } else {
          vehicleData = JSON.parse(document.querySelector(`option[value="${vehicleId}"]`).getAttribute('data-obj'));
          vehicleData.CatType = 1;
          reset_local_storage();
          sessionStorage.setItem('vehicleData', JSON.stringify(vehicleData));
          handle_search_request();
          document.querySelector('#original-search-close').click();
        }
      });
    }
    let vehicleSearch = document.getElementById('vehicle-Search');
    if(vehicleSearch) {
      document.getElementById('vehicle-Search').addEventListener('click', (event) => {
        event.preventDefault();
        vehicleId = document.getElementById('vehicleSelect').value;
        if(vehicleId == ""){
          alert('Please select a Vahicle');
        } else {
          vehicleData = JSON.parse(document.querySelector(`option[value="${vehicleId}"]`).getAttribute('data-obj'));
          vehicleData.CatType = 1;
          reset_local_storage();
          sessionStorage.setItem('vehicleData', JSON.stringify(vehicleData));
          handle_search_request();
          document.querySelector('#multi-search-close').click();
        }
      });
    }


    function scroll_element(selector) {       
      // Scroll to the target div with smooth behavior
      element = document.querySelector(selector);
      window.scrollTo({
          top: element.offsetTop,
          behavior: 'smooth'
      });
    }

    async function hashString(str) {
      const encoder = new TextEncoder();
      const data = encoder.encode(str);
      const hashBuffer = await crypto.subtle.digest('SHA-256', data);
      const hashArray = Array.from(new Uint8Array(hashBuffer));
      const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
      return hashHex;
    }


function attachAddToCartListeners() {
  const forms = document.querySelectorAll(`form[action="${window.routes.cart_add_url}"]`);

  forms.forEach(form => {
    console.log(form);
    if (!form.dataset.listenerAttached) {
      form.dataset.listenerAttached = 'true';

      form.addEventListener('submit', function () {
        setTimeout(() => {
          fetch(window.routes.cart_url + '.js')
            .then(res => res.json())
            .then(cart => {
              console.log('Cart updated:', cart);
              // 👉 Run custom logic
            });
        }, 500);
      });
    }
  });
}